import { CalendarMonth, Info, ThumbUp as ThumbUpIcon } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";
import ApplicantJobStatusButton from "components/ApplicantJobStatusButton";
import ApplicantPhoneButton from "components/ApplicantPhoneButton";
import ApplicantStageButton from "components/ApplicantStageButton";
import InterviewFeedbackButton from "components/InterviewFeedbackButton";
import { useAppContextController } from "context/AppContext";
import AddANoteModal from "layouts/pages/applicants/components/AddANoteModal";
import updateInterviewFeedback from "layouts/pages/events/actions/updateInterviewFeedback";
import { SnackbarProvider, useSnackbar } from "notistack";
import { useMemo, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { getApplicantJobEmploymentStage } from "utils/helpers/applicant";
import JobStatusMoreButton from "../../../CompanyJobsStatus/JobStatusRow/JobStatusMoreButton";

const thumbUpOptions = [
  {
    label: "None",
    color: "action",
  },
  {
    label: "Yes",
    color: "success",
  },
  {
    label: "Maybe",
    color: "warning",
  },
  {
    label: "No",
    color: "error",
  },
];

const InterviewRowActions = ({
  currentApplicant,
  refresh,
  isJobStatus,
  currentCustomer,
  isJobFull,
  onOpenTeamMemberModal,
  onOpenInterviewNotesModal,
  onOpenCreateInterviewModal,
  onChangeFeedback,
  navigateWithBack,
}) => {
  const queryClient = useQueryClient();

  const { currentJob, currentLoggedUser } = useAppContextController();
  const [toastAlert, setToastAlert] = useState(false);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const thumbOption = thumbUpOptions?.find(
    (option) => option.label === currentApplicant?.interview?.status
  );
  const [isNotesModalOpen, setNotesModalOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const jobAttachments = useMemo(() => {
    if (currentApplicant?.event?.attachments?.length) {
      return currentApplicant?.event?.attachments.map((att) => ({
        entity: "Event",
        group: "Interview",
        filename: att.filename,
        venueSlug: currentApplicant?.event?.companySlug,
        eventUrl: currentApplicant?.event?.eventUrl,
      }));
    }
    return [];
  }, [
    currentApplicant?.event?.attachments,
    currentApplicant?.event?.companySlug,
    currentApplicant?.event?.eventUrl,
  ]);

  const handleSaveNote = (noteRec) => {
    // const newNote = {
    //   type: "Interview Feedback",
    //   eventUrl: currentEvent?.eventUrl,
    //   text: noteRec.text,
    //   firstName: currentLoggedUser?.firstName,
    //   lastName: currentLoggedUser?.lastName,
    //   createAgent: currentLoggedUser?._id,
    //   date: new Date().toISOString(),
    // };
    //
    // return handleUpdateFeedback({ note: newNote });
  };

  const gridSize = isJobStatus ? 2 : 2.4;

  const employmentStage = getApplicantJobEmploymentStage(currentApplicant, currentJob.jobSlug);

  return (
    <>
      <SnackbarProvider
        maxSnack={3}
        open={toastAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setToastAlert(false)}
        key="top-center"
      >
        <Grid container spacing={1}>
          {thumbOption ? (
            <Grid item>
              <Tooltip title="View Interview">
                <IconButton
                  sx={{ paddingLeft: 0, paddingRight: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/events/${currentApplicant.interview?.eventUrl}`);
                  }}
                >
                  <Info fontSize="large" color="success" />
                </IconButton>
              </Tooltip>
            </Grid>
          ) : (
            <Grid item>
              <Tooltip title="No interview assigned">
                <IconButton
                  sx={{ paddingLeft: 0, paddingRight: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  disableRipple
                >
                  <Info fontSize="large" color="success" sx={{ opacity: 0.4 }} />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
          {thumbOption ? (
            <Grid item>
              <InterviewFeedbackButton
                sx={{ paddingLeft: 0, paddingRight: 0 }}
                applicant={currentApplicant}
                // refetchApplicants={refresh}
                onChangeFeedback={onChangeFeedback}
                eventUrl={currentApplicant?.event?.eventUrl}
                fontSize="large"
                isFinal
              />
            </Grid>
          ) : (
            <Grid item>
              <Tooltip title="No interview assigned">
                <IconButton
                  sx={{ paddingLeft: 0, paddingRight: 0 }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  disableRipple
                >
                  <ThumbUpIcon fontSize="large" color="dark" sx={{ opacity: 0.4 }} />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
          <Grid item>
            <Grid item>
              <ApplicantPhoneButton applicant={currentApplicant} />
            </Grid>
          </Grid>
          {isJobStatus && (
            <>
              <Grid item>
                <ApplicantStageButton
                  sx={{ paddingLeft: 0, paddingRight: 0 }}
                  applicant={currentApplicant}
                  job={currentJob}
                  refresh={refresh}
                />
              </Grid>
            </>
          )}
          <Grid item>
            <ApplicantJobStatusButton
              sx={{ paddingLeft: 0, paddingRight: 0 }}
              status={employmentStage}
              job={currentJob}
              applicant={currentApplicant}
              refresh={refresh}
              currentCustomer={currentCustomer}
              isJobFull={isJobFull}
            />
          </Grid>
          <Grid item>
            <JobStatusMoreButton
              applicant={currentApplicant}
              toastAlert={toastAlert}
              setToastAlert={setToastAlert}
              onNavigate={navigateWithBack}
              extraButtons={[
                {
                  color: "warning",
                  icon: "diversity_3",
                  clickAction: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOpenTeamMemberModal(currentApplicant);
                  },
                  tooltip: "Interview Team Members",
                },
                {
                  color: "success",
                  icon: "description",
                  clickAction: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOpenInterviewNotesModal(currentApplicant);
                  },
                  tooltip: "Interview Notes",
                },
                {
                  color: "success",
                  icon: "event",
                  clickAction: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOpenCreateInterviewModal(currentApplicant);
                  },
                  tooltip: "View Job Interviews",
                },
              ]}
              currentEvent={currentApplicant?.interview}
              messageContext="Applicant"
              attachmentContext="Job"
              customAttachments={jobAttachments}
              customTemplates={
                currentApplicant?.event?.description
                  ? [
                      {
                        name: "<< Interview Description >>",
                        subject: "Interview Invitation",
                        body: `<p>${currentApplicant?.event?.description}</p>`,
                      },
                    ]
                  : null
              }
            />
          </Grid>
        </Grid>
        <AddANoteModal
          currentApplicant={currentApplicant}
          open={isNotesModalOpen}
          toastAlert={toastAlert}
          setToastAlert={setToastAlert}
          setOpen={setNotesModalOpen}
          saveNote={handleSaveNote}
          showType={false}
        />
      </SnackbarProvider>
    </>
  );
};

export default InterviewRowActions;
